// according to this page: https://github.com/moroshko/react-autosuggest#onSuggestionSelectedProp

import React from 'react';
import PropTypes from 'prop-types';
import Styles from "../../../css";
import Autocomplete from "react-autosuggest";

import Constants from "../../../Constants";

const theme = {
    suggestionsList: Styles.autosuggest.suggestionsList,
    suggestionHighlighted: Styles.autosuggest.suggestionHighlighted,
    container: Styles.autosuggest.container,
    input: Styles.autosuggest.input,
    suggestion: Styles.combineStyles(Styles.fonts.commonFont,
        Styles.general.faded,
        {
            cursor: 'pointer',
            padding: '10px 20px',
        }
    ),
}


class Input extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currValue: props.inputProps.value || "",
            suggestions: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.shouldAutoComplete &&
            this.props.inputProps.value !== prevProps.inputProps.value &&
            this.props.inputProps.value !== this.state.currValue) {
            this.setState({ currValue: this.props.inputProps.value });
        }
    }

    /* functions for <Autocomplete /> */
    // this function filters the currently relevant options, when value is typed
    getSuggestions(value) {
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        let ret = inputLength === 0 ? [] : this.props.availableOptions.filter(opt =>
            opt.value.toLowerCase().includes(inputValue.toLowerCase())
        );

        // If there's no suggestion
        if(ret.length == 0 && inputLength > 0)
            ret = [ Constants.info.NO_SUGGESTIONS_OBJ ];

        return ret
    }

    // When suggestion is clicked, Autosuggest needs to populate the input
    // based on the clicked suggestion. Teach Autosuggest how to calculate the
    // input value for every given suggestion.
    getSuggestionValue(suggestion) {
        return suggestion.value;
    }

    // Render suggestions.
    renderSuggestion(suggestion, {query}) {
        // First check if the suggestion is the "no suggestions" suggestion.
        // In that case, render it differentaly
        if (this.isNoSuggestionsItem(suggestion))
            return (
                <div>
                    {suggestion.value}<b>{query}</b>
                </div>
            );

        const matchIndex = suggestion.value.toLowerCase().indexOf(query.toLowerCase());
        if (matchIndex === -1) {
            return <div>{suggestion.value}</div>;
        }

        const before = suggestion.value.substring(0, matchIndex);
        const match = suggestion.value.substring(matchIndex, matchIndex + query.length);
        const after = suggestion.value.substring(matchIndex + query.length);

        return (
            <div>
                {before}<b>{match}</b>{after}
            </div>
        );
    };

    // on input value change
    onChange(event) {
      const newValue = event.target.value;
      this.setState({
          currValue: newValue,
      });

      if (this.props.inputProps.onChange)
          this.props.inputProps.onChange(event, {newValue})
    };

    // Autosuggest will call this function every time you need to update suggestions.
    // We already implemented this logic above, so just use it.
    onSuggestionsFetchRequested({value}) {
        this.setState({
            suggestions: this.getSuggestions(value)
        });
    };

    // Autosuggest will call this function every time we need to clear suggestions.
    onSuggestionsClearRequested() {
        this.setState({ suggestions: [] });
    };

    // To simplify the callback for using components to only pass (in arguments) the selected obj
    onOptionSelectionWrapper(event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) {
        const passedCallback = this.props.onOptionSelection;
        const clickedItem = this.state.suggestions[suggestionIndex];

        // If the 'no suggestion' option was selected, ignore
        if(this.isNoSuggestionsItem(clickedItem)) {
            this.setState({currValue: this.state.currValue});
            return;
        }
        // Check if we should reset the input
        if (this.props.resetOnSelection)
            this.setState({currValue: ""});

        passedCallback(clickedItem);
    }

    isNoSuggestionsItem(item) { return item._id == Constants.info.NO_SUGGESTIONS_OBJ._id }

    render() {
        if(!this.props.inputProps.value) // if no value is specified from the outside
            this.props.inputProps.value = this.state.currValue; // Set it inside

        let input = <input { ...this.props.inputProps } onChange={this.onChange.bind(this)}/>;

        // If should autocomplete, replace the regular input with this
        if (this.props.shouldAutoComplete) {
            // render autocomplete instead
            const {currValue, suggestions} = this.state;


            // Autosuggest will pass through all these props to the input.
            // Object.assign is shallow cloning
            let inputProps = Object.assign({}, this.props.inputProps);
            inputProps.value = currValue || "";
            inputProps.onChange = this.onChange.bind(this);

            input = <Autocomplete
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion.bind(this)}
                inputProps={inputProps}
                onSuggestionSelected={this.onOptionSelectionWrapper.bind(this)}
                theme={theme}
            />
        }

        return (
            <span>
                { input }
            </span>
        );
    }
}

// Component prop types
Input.propTypes = {
    inputProps: PropTypes.object.isRequired, // The props passed to the input,
    shouldAutoComplete: PropTypes.bool.isRequired, // whether to Autocomplete
    onOptionSelection: PropTypes.func, // The function to be executed when selecting.
                                       // the header: func(objectSelected)
    availableOptions: PropTypes.array, // of objects with the key "value" as string.
                                       // The value is the string to be presented
    resetOnSelection: PropTypes.bool,  // Wether to erease the inpur after selecting
                                       // an option (if autocomplete is enabled)
}

Input.defaultProps = {
    shouldAutoComplete: false,
    resetOnSelection: false
}

export default Input;
